const Clock = `<svg fill="none" stroke="currentColor" stroke-linejoin="round" stroke-linecap="round"  viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="7.5"/><path d="m8.5 4.5v4"/><path d="m10.3066 10.1387-1.80932-1.5768"/></svg>`;

export { Clock as C };

//# sourceMappingURL=clock-add3e9a5.js.map